document.addEventListener('DOMContentLoaded', function () {
    const productForms = document.querySelectorAll('form[data-js-product-form="true"]');

    productForms.forEach(function (form) {
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            const formData = new FormData(form);

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => {
                if (response.ok) {
                    window.location.href = '/cart';
                } else {
                    alert('Something went wrong. Please try again.');
                }
            })
            .catch(error => console.error('Error:', error));
        });
    });
});
